var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStampIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_3888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 10.9453V11.6484C1.42969 11.8425 1.58719 12 1.78125 12H10.2188C10.4128 12 10.5703 11.8425 10.5703 11.6484V10.9453H1.42969Z",
    fill: "#4F4F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79158 4.14797C8.33205 3.57422 8.56127 2.79445 8.42017 2.00836C8.21627 0.870703 7.20189 0 6.00002 0C4.78431 0 3.78095 0.885234 3.57986 2.00836C3.43877 2.79445 3.66799 3.57422 4.20845 4.14797C4.57431 4.53656 4.70978 5.03367 4.759 5.38219C4.86236 6.11508 4.64017 6.66891 4.3615 7.07812H7.639C7.36009 6.66891 7.13791 6.11461 7.24103 5.38219C7.29025 5.03367 7.42572 4.53656 7.79158 4.14797Z",
    fill: "#4F4F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 10.2422H1.07812C0.883969 10.2422 0.726562 10.0848 0.726562 9.89062V9.53906C0.726562 8.5698 1.51512 7.78125 2.48438 7.78125H9.51562C10.4849 7.78125 11.2734 8.5698 11.2734 9.53906V9.89062C11.2734 10.0848 11.116 10.2422 10.9219 10.2422Z",
    fill: "#4F4F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_3888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampIcon);
export default __webpack_public_path__ + "static/media/stampIcon.a21040f3c7404c85a4a00555beb5881e.svg";
export { ForwardRef as ReactComponent };